const middleware = {}

middleware['authenticated'] = require('../src/app/middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['i18n'] = require('../src/app/middleware/i18n.js')
middleware['i18n'] = middleware['i18n'].default || middleware['i18n']

middleware['multirw'] = require('../src/app/middleware/multirw.js')
middleware['multirw'] = middleware['multirw'].default || middleware['multirw']

export default middleware
